<div style="overflow-x: auto; max-width: 100%">
  <p-table
    #dt
    [value]="users"
    [rows]="10"
    [paginator]="true"
    responsiveLayout="stack"
    [breakpoint]="'768px'"
    [globalFilterFields]="['username', 'firstName', 'lastName']"
    [tableStyle]="{ 'min-width': '100%' }"
    [rowHover]="true"
    [columnResizeMode]="'expand'"
    dataKey="id"
    styleClass="p-datatable-striped p-datatable-sm"
  >
    <ng-template pTemplate="caption">
      <div class="flex align-items-center justify-content-between">
        <button
          pButton
          pRipple
          label="Crear"
          icon="pi pi-plus"
          class="p-button-sm"
          (click)="crearUsuario()"
        ></button>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="username" class="p-col-12 p-md-4 p-lg-2">
          Usuario
          <p-sortIcon field="username"></p-sortIcon>
        </th>
        <th pSortableColumn="firstName" class="p-col-12 p-md-4 p-lg-2">
          Nombre
          <p-sortIcon field="firstName"></p-sortIcon>
        </th>
        <th pSortableColumn="lastName" class="p-col-12 p-md-4 p-lg-2">
          Apellido
          <p-sortIcon field="lastName"></p-sortIcon>
        </th>
        <th class="p-col-12 p-md-4 p-lg-2">Teléfono</th>
        <th class="p-col-12 p-md-4 p-lg-2">Email</th>
        <th class="p-col-12 p-md-4 p-lg-2">Rol</th>
        <th class="p-col-12 p-md-4 p-lg-2 p-sm-2">Acciones</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-user>
      <tr>
        <td
          [ngClass]="{
            'hidden p-0': !user.username && isMobile(),
            'p-1 border-bottom-1 border-solid border-gray-200': user.username
          }"
        >
          <div class="p-column-title font-bold">Usuario</div>
          <div class="md:col-12 col-6 p-0">
            {{ user.username }}
          </div>
        </td>
        <td
          [ngClass]="{
            'hidden p-0': !user.firstName && isMobile(),
            'p-1 border-bottom-1 border-solid border-gray-200': user.firstName
          }"
        >
          <div class="p-column-title font-bold">Nombre</div>
          <div class="md:col-12 col-6 p-0">
            {{ user.firstName | titlecase }}
          </div>
        </td>
        <td
          [ngClass]="{
            'hidden p-0': !user.lastName && isMobile(),
            'p-1 border-bottom-1 border-solid border-gray-200': user.lastName
          }"
        >
          <div class="p-column-title font-bold">Apellido</div>
          <div class="md:col-12 col-6 p-0">
            {{ user.lastName | titlecase }}
          </div>
        </td>
        <td
          [ngClass]="{
            'hidden p-0': !user.phone && isMobile(),
            'p-1 border-bottom-1 border-solid border-gray-200': user.phone
          }"
        >
          <div class="p-column-title font-bold">Teléfono</div>
          <div class="md:col-12 col-6 p-0">
            {{ user.phone ? user.phone : 'S/N' }}
          </div>
        </td>
        <td
          [ngClass]="{
            'hidden p-0': !user.email && isMobile(),
            'p-1 border-bottom-1 border-solid border-gray-200': user.email
          }"
        >
          <div class="p-column-title font-bold">Email</div>
          <div class="md:col-12 col-6 p-0">
            {{ user.email }}
          </div>
        </td>
        <td
          [ngClass]="{
            'hidden p-0': !user.userRole && isMobile(),
            'p-1 border-bottom-1 border-solid border-gray-200': user.userRole
          }"
        >
          <div class="p-column-title font-bold">Rol</div>
          <div class="md:col-12 col-6 p-0">
            {{ user.userRole === 'buyer' ? 'Comprador' : user.userRole }}
          </div>
        </td>
        <td class="justify-content-center gap-3">
          <button
            pButton
            pRipple
            icon="pi pi-pencil"
            class="p-button-rounded p-button-success p-button-sm"
            (click)="Editar(user)"
          ></button>
          <button
            type="button"
            pButton
            pRipple
            icon="pi pi-trash"
            class="p-button-rounded p-button-warning p-button-sm"
            (click)="Eliminar(user)"
          ></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
<app-modaluser />
